import { SubscriptionsView } from "../features/subscriptions";

export const Subscriptions = () => {
  return <SubscriptionsView />;
};
